/*
 * SIMBA — ĐỊNH DẠNG & BUỔI HỌC
 * ============================================================================
 * Ngày giờ hiển thị theo giờ địa phương của người học và các phép chọn buổi học
 * sắp tới. Giữ chung một chỗ để mọi trang đọc cùng một định dạng.
 */
export function formatDisplayDate(value?: string) {
  if (!value) return "Chưa có ngày";
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
  return match ? `${match[3]}.${match[2]}.${match[1]}` : value;
}

// Today's date as a local YYYY-MM-DD string, for day-granularity comparison
// against session_date (which is also YYYY-MM-DD) without timezone drift.
export function localTodayISO() {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

// A session is hidden once a mentor marks it cancelled/hidden.
export function isVisibleSession(s: any) {
  const status = String(s?.status || "").toLowerCase();
  return !!s && status !== "cancelled" && status !== "hidden" && !s.hidden && !s.is_hidden;
}

// A session's display title: only show a distinct title, otherwise fall back
// to "Buổi N" ONCE (avoids the "Buổi 2 Buổi 2" duplication).
export function sessionDisplayTitle(s: any) {
  const t = String(s?.title || "").trim();
  return t && t !== `Buổi ${s.session_number}` ? t : "";
}

// The "next" session is the first one that hasn't happened yet — not
// sessions[0], which is always Buổi 1 and stays in the past forever.
// Falls back to the most recent past session (course finished), then the
// first session if none carry a date. Cancelled/hidden sessions are excluded.
export function pickNextSession(sessions: any[]) {
  const list = (Array.isArray(sessions) ? sessions : []).filter(isVisibleSession);
  if (list.length === 0) return { next: undefined as any, rest: [] as any[] };
  const today = localTodayISO();
  const dated = list.filter((s) => s?.session_date);
  const upcoming = dated
    .filter((s) => String(s.session_date).slice(0, 10) >= today)
    .sort((a, b) => String(a.session_date).localeCompare(String(b.session_date)));
  const mostRecentPast = [...dated].sort((a, b) =>
    String(b.session_date).localeCompare(String(a.session_date)),
  )[0];
  const next = upcoming[0] || mostRecentPast || list[0];
  const rest = list.filter((s) => s !== next);
  return { next, rest };
}

export function formatDateTime(value?:string){
  if(!value)return "";
  const date=new Date(value),parts=new Intl.DateTimeFormat("vi-VN",{day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit",hour12:false}).formatToParts(date),part=(type:string)=>parts.find(item=>item.type===type)?.value||"";
  return `${part("day")}.${part("month")}.${part("year")} · ${part("hour")}:${part("minute")}`;
}
